module.exports = __webpack_public_path__ + "static/media/Heart.3619b5d7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Icons/Heart.svg
// module id = 144
// module chunks = 0